module.exports = __webpack_public_path__ + "static/media/mp4-icon.7e10df0a.svg";